import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const Category = async () => {
  try {
    return await getData(`/without-login/allcategories`);
  } catch (error) {
    console.log(error);
  }
};

export const SubCategory = async (id) => {
  try {
    return await getData(`/without-login/allsubcategories/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const singleSubCategory = async (id) => {
  try {
    return await getData(`/without-login/subcategory/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const ChildSubCategory = async (id) => {
  try {
    return await getData(`/without-login/allchildsubcategories/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const popularCategory = async () => {
  try {
    return await getData(`/without-login/all-pupular-category`);
  } catch (error) {
    console.log(error);
  }
};

export const popularProduct = async (city) => {
  try {
    return await getData(`/without-login/product/popular-product?city=${city}`);
  } catch (error) {
    console.log(error);
  }
};

export const SaleBanner = async () => {
  try {
    return await getData(`/without-login/home/salebanner`);
  } catch (error) {
    console.log(error);
  }
};

export const Products = async (
  category_id = "",
  sub_category_id = "",
  priceOrder = "",
  user_id = "",
  brand_id = "",
  name = "",
  city
) => {
  try {
    let url = `/without-login/product?category_id=${
      category_id || ""
    }&sub_category_id=${sub_category_id || ""}&priceOrder=${
      priceOrder || ""
    }&user_id=${user_id || ""}&brand_id=${brand_id || ""}&name=${name || ""}&city=${city || ""}`;

    // if (category_id && sub_category_id && child_sub_category_id && seller_id) {
    //   url += `?category_id=${category_id}&sub_category_id=${sub_category_id}&child_sub_category_id=${child_sub_category_id}&seller_id=${seller_id}`;
    // } else if (category_id) {
    //   url += `?category_id=${category_id}`;
    // } else if (sub_category_id) {
    //   url += `?sub_category_id=${sub_category_id}`;
    // } else if (child_sub_category_id) {
    //   url += `?child_sub_category_id=${child_sub_category_id}`;
    // }

    // if (seller_id) {
    //   url += `&seller_id=${seller_id}`;
    // }
    return await getData(url);
  } catch (error) {
    console.log(error);
  }
};

export const getProductDetail = async (id) => {
  try {
    return await getData(`/without-login/product/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const ProductDetail = async () => {
  try {
    return await getData("/without-login/product/productdetails");
  } catch (error) {
    console.log(error);
  }
};

export const CategoryProduct = async () => {
  try {
    return await getData("/without-login/all-category-product");
  } catch (error) {
    console.log(error);
  }
};

export const getProductVariant = async (id) => {
  try {
    return await getData(`/without-login/product/variants/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const getAllVariant = async () => {
  try {
    return await getData(`/without-login/product/all-variant`);
  } catch (error) {
    console.log(error);
  }
};

export const getVariant = async (id) => {
  try {
    return await getData(`/without-login/product/variant/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const allProductReviewGet = async (id) => {
  try {
    return await getData(`/without-login/home/show/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const productReviewGet = async (id) => {
  try {
    return await getData(`/review/show/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const productReviewPost = async (data) => {
  try {
    return await postData(`/review/add`, data);
  } catch (error) {
    console.log(error);
  }
};

export const productList = async () => {
  try {
    return await getData(`/without-login/product`);
  } catch (error) {
    console.log(error);
  }
};

export const NewInStore = async (userId,city) => {
  try {
    return await getData(
      `/without-login/product/new-instore?user_id=${userId || ""}&city=${city||""}`
    );
  } catch (error) {
    console.log(error);
  }
};

export const PostSearchHistory = async (name,location) => {
  try {
    return await postData(`/without-login/product/search-history`, {
      name,
      location
    });
  } catch (error) {
    console.log(error);
  }
};
